import { Button, Dialog, Modal, ModalRef } from 'alurkerja-ui';
import { OutlineButton } from '@/components/shared/button/OutlineButton';
import { useRef } from 'react';
import { ProjectAssigneeService } from '@/api/projectAssignee';
import { FaTrash } from 'react-icons/fa';

type DeleteAssigneeProps = {
  projectId: string;
  onSuccess?: () => void;
};

export const DeleteAssignee: React.FC<DeleteAssigneeProps> = ({
  projectId,
  onSuccess,
}) => {
  const ref = useRef<ModalRef>(null);
  const { mutate, isPending } = ProjectAssigneeService.useDelete();

  const deleteAction = (id: string) => {
    mutate(id, {
      onSuccess: () => {
        Dialog.success({
          title: 'Success',
          description: 'Assignee has been deleted',
          callback: () => {
            ref.current?.closeModal();
            onSuccess?.();
          },
        });
      },
      onError: () => {
        Dialog.error({
          title: 'Failed',
          description: 'Assignee failed to delete',
        });
      },
    });
  };

  return (
    <Modal
      ref={ref}
      title="Delete Assignee"
      triggerButton={
        <Button className="bg-red-600">
          <FaTrash />
        </Button>
      }
    >
      {({ closeModal }) => (
        <div className="flex flex-col gap-4 p-4">
          <p className="text-gray-500">
            Are you sure you want to delete this Assignee? This action cannot be
            undone.
          </p>
          <div className="flex flex-row gap-2">
            <OutlineButton onClick={closeModal}>Cancel</OutlineButton>
            <Button
              type="button"
              color="red"
              onClick={() => deleteAction(projectId)}
              disabled={isPending}
            >
              Delete
            </Button>
          </div>
        </div>
      )}
    </Modal>
  );
};
